import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { Affix, Layout } from 'antd';

import { Menu } from './menu';

export const Sidebar = () => {
  const dispatch = useAppDispatch();
  const { isCollapsed } = useAppSelector(uiModel.Layout.selectors.selectLayout);

  const resizeListener = () => {
    if (window.innerWidth < 1281) {
      dispatch(uiModel.Layout.actions.setIsCollapsed(true));
    } else {
      dispatch(uiModel.Layout.actions.setIsCollapsed(false));
    }
  };

  useEffect(() => {
    resizeListener();
    window.addEventListener('resize', resizeListener);
    return () => window.removeEventListener('resize', resizeListener);
  }, []);

  return (
    <Layout.Sider width={268} theme="light" collapsed={isCollapsed}>
      <Menu />
    </Layout.Sider>
  );
};
